import { observatoryData, observatoryMetadata } from "../config";
import { getCurrentObservatoryName } from "../utils";

/**
 * Update the all-sky camera image, pulling from Ramotswe data or a preset "not available"
 */
export async function updateAllSkyImage() {
  const observatoryName = getCurrentObservatoryName();

  if (observatoryMetadata[observatoryName].endpoints.allSky) {
    // pull new image
    await observatoryData[observatoryName].allSkyImage.update();
    setAllSkyImage(observatoryData[observatoryName].allSkyImage.blobURL);
  } else {
    setAllSkyImage("/images/placeholder.png");
  }
}

/**
 * Utility function to change the all-sky image source
 * @param {string} src - Image URL
 */
export function setAllSkyImage(src) {
  document.getElementById("all-sky-camera-image").setAttribute("src", src);
  document.getElementById("current-status-image").setAttribute("src", src);
}
